export default __webpack_public_path__ + "media/zurb/img/events/wired/sacred-heart/sacred-heart-thumb-bf701cf8df8eb942a162894400aa2bd5.png";